export default __webpack_public_path__ + "static/media/przysmak_mobile.1b3e461d.webp";